const prefix = 'arkhrms:keychain:';

export async function setGenericPassword(username, password, options = {}) {
  window.localStorage.setItem(
    `${prefix}${options.service || 'default'}`,
    JSON.stringify({username, password}),
  );
  return true;
}

export async function getGenericPassword(options = {}) {
  const raw = window.localStorage.getItem(`${prefix}${options.service || 'default'}`);
  if (!raw) return false;
  try {
    return JSON.parse(raw);
  } catch {
    return false;
  }
}

export async function resetGenericPassword(options = {}) {
  window.localStorage.removeItem(`${prefix}${options.service || 'default'}`);
  return true;
}
